import MuiRating from '@mui/material/Rating'
import { ReactNode, useState } from 'react'
import { ratingStyles } from './Rating.styles'
import styles from './Rating.module.scss'

interface RatingProps {
  defaultValue?: number
  size?: string
  precision?: number
  isReadOnly?: boolean
  icon?: ReactNode
  max?: number
  label?: string
  /**
   * Supply both to drive the value from outside. Left out, the component keeps
   * its own state as before — which every read-only caller relies on, and which
   * silently swallowed the value when it was used inside a form.
   */
  value?: number | null
  onChange?: (value: number | null) => void
}

function Rating(props: RatingProps) {
  const {
    defaultValue,
    size,
    precision,
    isReadOnly = false,
    icon,
    max = 5,
    label,
    value: controlledValue,
    onChange
  } = props

  const [uncontrolledValue, setUncontrolledValue] = useState<number | null>(
    defaultValue ?? null
  )
  const isControlled = controlledValue !== undefined
  const value = isControlled ? controlledValue : uncontrolledValue
  return (
    <div className={styles.ratingWrapper}>
      <p
        className={`label-bold-medium ${styles.ratingLabel} ${
          value ? styles.ratingLabelActive : ''
        }`}
      >
        {label}
      </p>
      <MuiRating
        sx={{
          ...ratingStyles,
          '&.MuiRating-root': {
            fontSize: size || '2rem'
          }
        }}
        value={value}
        precision={precision || 0.1}
        readOnly={isReadOnly}
        icon={icon}
        emptyIcon={icon}
        max={max}
        onChange={(_, newValue) => {
          if (!isControlled) setUncontrolledValue(newValue)
          onChange?.(newValue)
        }}
      />
    </div>
  )
}

export default Rating
